<!-- Compact Modern Statistics Dashboard -->
<div class="modern-statistics-container">
  <!-- Content Area -->
  <main class="stats-content">
    <!-- Events Tab -->
    <div *ngIf="currentTabIndex === 0" class="stats-view">
      <div class="compact-table-container">
        <div class="table-header-section">
          <div class="stats-summary">
            <div class="summary-card">
              <span class="summary-value">{{ result[result.length - 1]?.count || 0 }}</span>
              <span class="summary-label">Total Events</span>
            </div>
            <div class="summary-card">
              <span class="summary-value">{{ result[result.length - 1]?.archivedCount || 0 }}</span>
              <span class="summary-label">Archived</span>
            </div>
          </div>
          <div class="search-section">
            <div class="year-input-group">
              <input type="number" [(ngModel)]="year" (keydown.enter)="search()" placeholder="Year" class="year-input" />
              <button class="search-btn" [disabled]="year === null" (click)="search()">
                <svg viewBox="0 0 24 24">
                  <path
                    d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="compact-table events-monthly-table" *ngIf="result.length">
          <div class="table-header">
            <div class="table-cell">Month</div>
            <div class="table-cell">New</div>
            <div class="table-cell">Archived</div>
          </div>
          <div class="table-body">
            <div class="table-row" *ngFor="let item of result; let i = index" [class.hidden]="i === result.length - 1">
              <div class="table-cell month-cell">{{ item.displayMonth }}</div>
              <div class="table-cell value-cell new">{{ item.count }}</div>
              <div class="table-cell value-cell archived">{{ item.archivedCount }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Workspaces Tab -->
    <div *ngIf="currentTabIndex === 1" class="stats-view">
      <div class="compact-table-container">
        <div class="table-header-section">
          <div class="stats-summary">
            <div class="summary-card">
              <span class="summary-value">{{ result[result.length - 1]?.count || 0 }}</span>
              <span class="summary-label">Total Workspaces</span>
            </div>
          </div>
          <div class="search-section">
            <div class="year-input-group">
              <input type="number" [(ngModel)]="year" (keydown.enter)="search()" placeholder="Year" class="year-input" />
              <button class="search-btn" [disabled]="year === null" (click)="search()">
                <svg viewBox="0 0 24 24">
                  <path
                    d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="compact-table workspaces-table" *ngIf="result.length">
          <div class="table-header">
            <div class="table-cell">Month</div>
            <div class="table-cell">New Workspaces</div>
          </div>
          <div class="table-body">
            <div class="table-row" *ngFor="let item of result; let i = index" [class.hidden]="i === result.length - 1">
              <div class="table-cell month-cell">{{ item.displayMonth }}</div>
              <div class="table-cell value-cell new">{{ item.count }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Trusted Names Tab -->
    <div *ngIf="currentTabIndex === 2" class="stats-view">
      <div class="compact-table-container">
        <div class="table-header-section">
          <div class="stats-summary">
            <div class="summary-card">
              <span class="summary-value">{{ genderList.length }}</span>
              <span class="summary-label">Total Names</span>
            </div>
          </div>
          <div class="search-section">
            <div class="search-input-group">
              <input type="text" placeholder="Search names..." [(ngModel)]="searchTerm" (ngModelChange)="searchTerm$.next($event)" class="search-input" />
              <svg viewBox="0 0 24 24" class="search-icon">
                <path
                  d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                />
              </svg>
            </div>
            <button class="add-btn" (click)="openAddNameDialog()">
              <svg viewBox="0 0 24 24">
                <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
              </svg>
              Add
            </button>
          </div>
        </div>

        <div class="compact-table trusted-names-table">
          <div class="table-header">
            <div class="table-cell">Name</div>
            <div class="table-cell">Gender</div>
            <div class="table-cell">Actions</div>
          </div>
          <div class="table-body">
            <div class="table-row" *ngFor="let record of genderList; let i = index">
              <div class="table-cell name-cell">
                <input type="text" class="name-input" [ngModel]="genderList[i].first_name | titlecase" (blur)="onNameBlur($event.target.value, i)" />
              </div>
              <div class="table-cell gender-cell">
                <span class="gender-badge" [class]="'gender-' + record.gender">{{ record.gender | titlecase }}</span>
              </div>
              <div class="table-cell actions-cell">
                <div class="action-buttons">
                  <button class="gender-btn male" [class.active]="record.gender === 'male'" [disabled]="record.gender === 'male'" (click)="editGender(record, 'male')">M</button>
                  <button class="gender-btn female" [class.active]="record.gender === 'female'" [disabled]="record.gender === 'female'" (click)="editGender(record, 'female')">
                    F
                  </button>
                  <button class="delete-btn" (click)="confirmDelete(i)">
                    <svg viewBox="0 0 24 24">
                      <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pagination-container" *ngIf="lastPage > 1">
          <button class="pagination-btn" [disabled]="currentPage === 1" (click)="changePage(currentPage - 1)">
            <svg viewBox="0 0 24 24">
              <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
            </svg>
            Previous
          </button>
          <span class="pagination-info">{{ currentPage }} / {{ lastPage }}</span>
          <button class="pagination-btn" [disabled]="currentPage >= lastPage" (click)="changePage(currentPage + 1)">
            Next
            <svg viewBox="0 0 24 24">
              <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Live Events Tab -->
    <div *ngIf="currentTabIndex === 3" class="stats-view">
      <div class="compact-table-container">
        <div class="table-header-section">
          <div class="stats-summary">
            <div class="summary-card live">
              <span class="summary-value">{{ liveEventsCount }}</span>
              <span class="summary-label">Live Now</span>
            </div>
            <div class="summary-card upcoming">
              <span class="summary-value">{{ plannedEventCount }}</span>
              <span class="summary-label">Upcoming</span>
            </div>
            <div class="summary-card">
              <span class="summary-value">{{ allEvents.length }}</span>
              <span class="summary-label">Total</span>
            </div>
          </div>
          <div class="search-section">
            <div class="year-input-group">
              <input type="number" [(ngModel)]="year" (keydown.enter)="loadLiveAndPlannedEvents()" placeholder="Year" class="year-input" />
              <button class="search-btn" [disabled]="year === null" (click)="loadLiveAndPlannedEvents()">
                <svg viewBox="0 0 24 24">
                  <path
                    d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                  />
                </svg>
              </button>
            </div>
            <div class="filter-pills">
              <button class="filter-pill" [class.active]="currentFilter === 'All'" (click)="filter('All')">All</button>
              <button class="filter-pill live" [class.active]="currentFilter === 'Live'" (click)="filter('Live')">Live</button>
              <button class="filter-pill upcoming" [class.active]="currentFilter === 'Upcoming'" (click)="filter('Upcoming')">Upcoming</button>
            </div>
          </div>
        </div>

        <div class="compact-table events-table">
          <div class="table-header">
            <div class="table-cell">Event</div>
            <div class="table-cell">Status</div>
            <div class="table-cell">Workspace</div>
            <div class="table-cell">Start</div>
            <div class="table-cell">End</div>
            <div class="table-cell clickable" (click)="filter('payment')">
              Payment
              <svg viewBox="0 0 24 24" class="sort-icon" *ngIf="paymentFilter === 'yes'">
                <path d="M7.41,8.58L12,4L16.59,8.58L15.17,10L12,6.83L8.83,10L7.41,8.58Z" />
              </svg>
              <svg viewBox="0 0 24 24" class="sort-icon" *ngIf="paymentFilter === 'no'">
                <path d="M7.41,15.41L12,20L16.59,15.41L15.17,14L12,17.17L8.83,14L7.41,15.41Z" />
              </svg>
            </div>
          </div>
          <div class="table-body">
            <div class="table-row" *ngFor="let record of liveAndplannedEvents">
              <div class="table-cell event-cell">{{ record.event_name }}</div>
              <div class="table-cell status-cell">
                <span class="status-badge" [class]="'status-' + record.status.toLowerCase()">{{ record.status }}</span>
              </div>
              <div class="table-cell workspace-cell">{{ record.workspace_name }}</div>
              <div class="table-cell date-cell">{{ record.start_date | date : 'dd/MM/yy' }}</div>
              <div class="table-cell date-cell">{{ record.end_date | date : 'dd/MM/yy' }}</div>
              <div class="table-cell payment-cell">
                <span class="payment-badge" [class]="'payment-' + record.collect_payment.toLowerCase()">{{ record.collect_payment }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SMS Events Tab -->
    <div *ngIf="currentTabIndex === 4" class="stats-view">
      <div class="compact-table-container">
        <div class="table-header-section">
          <div class="stats-summary">
            <div class="summary-card">
              <span class="summary-value">{{ smsEvents.length }}</span>
              <span class="summary-label">SMS Events</span>
            </div>
            <div class="summary-card cost">
              <span class="summary-value">${{ getTotalSmsCost() }}</span>
              <span class="summary-label">Total Cost</span>
            </div>
          </div>
          <div class="search-section">
            <div class="year-input-group">
              <input type="number" [(ngModel)]="year" (keydown.enter)="getSmsEvents()" placeholder="Year" class="year-input" />
              <button class="search-btn" [disabled]="year === null" (click)="getSmsEvents()">
                <svg viewBox="0 0 24 24">
                  <path
                    d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="compact-table sms-table" *ngIf="smsEvents.length">
          <div class="table-header">
            <div class="table-cell">Event Name</div>
            <div class="table-cell">SMS Cost</div>
            <div class="table-cell">SMS Count</div>
          </div>
          <div class="table-body">
            @for (event of smsEvents; track $index) {
            <div class="table-row">
              <div class="table-cell event-cell">{{ event.name }}</div>
              <div class="table-cell cost-cell">{{ event.sms_cost | currency : '$' }}</div>
              <div class="table-cell count-cell tw-group tw-flex tw-items-center tw-justify-center tw-gap-3">
                <span class="tw-min-w-[1.5ch] tw-text-right tw-font-semibold tw-text-slate-800">{{ event.sms_count }}</span>
                <button
                  type="button"
                  class="tw-flex tw-h-7 tw-w-7 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-bg-transparent tw-p-0 tw-text-slate-400 tw-opacity-45 tw-transition-[opacity,color,background] tw-duration-150 hover:tw-bg-blue-50 hover:tw-text-blue-600 hover:tw-opacity-100 focus-visible:tw-opacity-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-1 focus-visible:tw-outline-blue-300 disabled:tw-cursor-not-allowed disabled:tw-opacity-35 group-hover:enabled:tw-opacity-100"
                  [disabled]="isRefreshingSms(event)"
                  (click)="refreshSmsCount(event, $index)"
                  title="Refresh SMS count"
                  aria-label="Refresh SMS count for {{ event.name }}"
                >
                  <svg class="tw-h-4 tw-w-4 tw-fill-current" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z"
                    />
                  </svg>
                </button>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
